import UI from './utils/UI'
import { mq } from './config'
import bus from './bus'

UI({
  component: '.js-termNav',
  list: '.js-termNav-list',
  select: '.js-termNav-select'
}, ({ list, select }) => {
  toggleTabIndex()
  bus.on('window-resize', toggleTabIndex)
  select.addEventListener('change', handleSelectChange, false)

  function handleSelectChange (evt) {
    const to = evt.target.value
    if (to !== window.location.href) {
      window.location = to
    }
  }

  function toggleTabIndex () {
    select.setAttribute('tabIndex', mq.md.matches ? -1 : 0)
    Array.from(list.querySelectorAll('a')).forEach(a => a.setAttribute('tabIndex', mq.md.matches ? 0 : -1))
  }
})
